var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1000004816(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3726 7.73443C13.621 7.44734 13.9702 7.26655 14.348 7.22932C14.7259 7.19208 15.1036 7.30123 15.4033 7.53431C15.439 7.55982 15.4714 7.58969 15.4997 7.62324L16.5299 8.43113C16.6911 8.52982 16.8313 8.6593 16.9424 8.8122C17.0535 8.96511 17.1333 9.13841 17.1774 9.32221C17.2214 9.506 17.2288 9.69672 17.1991 9.88337C17.1694 10.07 17.1032 10.249 17.0043 10.41L16.9301 10.5212L10.7859 18.3553C10.6858 18.4864 10.5568 18.5927 10.409 18.6659C10.2612 18.7392 10.0985 18.7774 9.93357 18.7777H7.56186L7.02822 16.4727C6.99165 16.3119 6.99061 16.145 7.02517 15.9837C7.05973 15.8224 7.12906 15.6706 7.22833 15.5388L13.3726 7.73443Z",
    stroke: "#200E32",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2236 9.20178L15.7812 11.9886",
    stroke: "#200E32",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000004816);
export default __webpack_public_path__ + "static/media/Group 1000004816.150fd8ffbb93f58ed816e621017917b9.svg";
export { ForwardRef as ReactComponent };